import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useAppStore } from "@/hooks/useAppStore";
import { useAudioRecorder } from "@/hooks/useAudioRecorder";
import { useTranslation } from "@/lib/translate";


interface MicrophoneDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const MicrophoneDialog: React.FC<MicrophoneDialogProps> = ({
  open,
  onOpenChange,
}) => {
  const preferredLanguage = useAppStore((state) => state.preferredLanguage);
  const { changeMicrophoneInput } = useAudioRecorder();
  const micInput = useAppStore((state) => state.micInput);
  const [inputDevices, setInputDevices] = useState<any[]>([]);
  const t = useTranslation(preferredLanguage);

  const getInputDevices = async () => {
    const devices = await navigator.mediaDevices.enumerateDevices();
    setInputDevices(devices.filter((device) => { return device.kind === 'audioinput'; }));
  }

  useEffect(() => {
    const handleDeviceChange = () => {
      getInputDevices();
    };

    navigator.mediaDevices.addEventListener('devicechange', handleDeviceChange);

    return () => {
      navigator.mediaDevices.removeEventListener('devicechange', handleDeviceChange);
    };
  }, []);

  useEffect(() => {
    getInputDevices();
  }, []);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] bg-neutral-800 border-neutral-700 text-white">
        <DialogHeader>
          <DialogTitle className="text-center text-lg">
            {t("Microphone")}
          </DialogTitle>
        </DialogHeader>

        {[...inputDevices].map((device) => (
          <div key={device.deviceId}
            className={
              "shadow-xs border rounded-md text-sm overflow-hidden "
              + (micInput === device.deviceId
                ? "bg-primary text-primary-foreground"
                : "bg-secondary text-secondary-foreground hover:bg-chotto-blue/60"
              )
            }
            onClick={() => {
              changeMicrophoneInput(device.deviceId);
              onOpenChange(false);
            }
            }>
            <input
              className="m-2"
              type="radio"
              name={device.deviceId}
              value={device.deviceId}
              defaultChecked={micInput === device.deviceId}
            />
            <label className="inline-block whitespace-nowrap w-10 m-1">{device.label}</label>
          </div>
        ))}

        <DialogFooter className="sm:justify-center">
          <Button
            type="button"
            variant="secondary"
            onClick={() => onOpenChange(false)}>
            {t("Close")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
